/**
 * Export use case types
 * Must match the expected values set in Orc/appsettings.json
 */
export enum ExportType {
    Iris = 'iris',
    OfferWallet = 'offerwallet',
    PublisherCampaigns = 'publishercampaigns',
    UserResearch = 'xboxresearch',
    Xandr = 'xandr',
    CosmosExport = 'cosmosexport',
    GroupsExport = 'groupsservice',
    InternalTest = 'internaltest',
    InternalADFTest = 'internaltest_adf'
}

const DUKE_ENABLED_EXPORT_TYPES = new Set<ExportType>([
    ExportType.OfferWallet,
    ExportType.PublisherCampaigns,
    ExportType.UserResearch,
    ExportType.CosmosExport,
]);

export const getExportDataset = (sessionDataset: string, selectedDataset: string): string => {
    const normalizedSessionDataset = sessionDataset.trim();
    return normalizedSessionDataset || selectedDataset.trim();
};

export const isExportFeatureEnabled = (featureEnabled: boolean): boolean =>
    featureEnabled;

export const isExportTypeDisabled = (dataset: string, exportType: ExportType): boolean =>
    dataset.trim().toLowerCase() === 'duke' && !DUKE_ENABLED_EXPORT_TYPES.has(exportType);